import { UserType } from '../../../features/workflow/types';

export function sortUsers(_aUser: UserType, _bUser: UserType): number {
  return 0;
}
